"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProcessor = getProcessor;
exports.getComponent = getComponent;
exports.getNextAtom = getNextAtom;
exports.getAtomSubRuleId = getAtomSubRuleId;
exports.getDefaultValue = getDefaultValue;
exports.getValue = getValue;
exports.newRuleValues = newRuleValues;
exports.newRule = newRule;
exports.getAtoms = getAtoms;
exports.updateRule = updateRule;
exports.isValidValue = isValidValue;
exports.isGenericValidValue = isGenericValidValue;
exports.registerType = registerType;
exports.unregisterType = unregisterType;
exports.defaultAtomProcessor = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var dispatch = {
  component: {},
  nextAtom: {},
  subRule: {},
  validator: {},
  atomProcessor: {}
};
var PROCESSOR_TYPES = {
  ATOM: "atom",
  DEFAULT: "default",
  VALUE: "value"
};

var defaultAtomProcessor = function defaultAtomProcessor(idx, atom, values, parentValues) {
  return atom;
};

exports.defaultAtomProcessor = defaultAtomProcessor;

function getProcessor(_ref) {
  var atomId = _ref.atomId,
      _ref$processors = _ref.processors,
      processors = _ref$processors === void 0 ? {} : _ref$processors,
      type = _ref.type;

  if (processors[atomId] && processors[atomId][type]) {
    return processors[atomId][type];
  } else {
    switch (type) {
      case PROCESSOR_TYPES.ATOM:
        return function (idx, atom, values, parentValues) {
          return dispatch.atomProcessor[atom.type](idx, atom, values, parentValues);
        };

      case PROCESSOR_TYPES.DEFAULT:
        return function (idx, atom, values) {
          return atom.id && atom.default !== undefined ? {
            id: atom.id,
            idx: idx,
            value: atom.default
          } : undefined;
        };

      case PROCESSOR_TYPES.VALUE:
        return function (idx, atom, value, values, parentValues) {
          return value;
        };

      default:
        throw new Error("Cannot getProcessor of type ".concat(type));
    }
  }
}

function getComponent(type) {
  if (dispatch.component[type] === undefined) {
    throw new Error("Cannot get component of type ".concat(type, " : undefined"));
  }

  return dispatch.component[type];
}

function getNextAtom(_ref2) {
  var atom = _ref2.atom,
      idx = _ref2.idx,
      values = _ref2.values,
      ruleBook = _ref2.ruleBook,
      processors = _ref2.processors,
      parentValues = _ref2.parentValues;
  var value = getValue(idx, atom, values) || getDefaultValue(idx, atom, values, processors);

  if (dispatch.nextAtom[atom.type] === undefined) {
    throw new Error("Cannot get atom of type ".concat(atom.type, " : undefined"));
  }

  var unprocessedAtom = ruleBook[dispatch.nextAtom[atom.type](atom, value)];

  if (!unprocessedAtom) {
    return undefined;
  }

  var atomProcessor = getProcessor({
    atomId: unprocessedAtom.id,
    processors: processors,
    type: PROCESSOR_TYPES.ATOM
  });
  var nextAtom = atomProcessor(idx, unprocessedAtom, values, parentValues);
  return nextAtom;
}

function getNextGenericAtom(atom) {
  return atom.next;
}

function getAtomSubRuleId(_ref3) {
  var idx = _ref3.idx,
      atom = _ref3.atom,
      values = _ref3.values,
      processors = _ref3.processors;

  if (dispatch.subRule[atom.type] === undefined) {
    throw new Error("Cannot get sub rule of type ".concat(atom.type, " : undefined"));
  }

  return dispatch.subRule[atom.type]({
    idx: idx,
    atom: atom,
    values: values,
    processors: processors
  });
}

function getGenericAtomSubRuleId(_ref4) {
  var atom = _ref4.atom;
  var subRuleId = atom.subRule;
  var requiredSubRule = Boolean(atom.requiredSubRule);
  var singleSubRule = Boolean(atom.singleSubRule);
  var subRuleType = atom.subRuleType;
  return subRuleId ? {
    subRuleId: subRuleId,
    requiredSubRule: requiredSubRule,
    singleSubRule: singleSubRule,
    subRuleType: subRuleType
  } : {};
}

function getDefaultValue(idx, atom) {
  var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var processors = arguments.length > 3 ? arguments[3] : undefined;
  var defaultProcessor = getProcessor({
    atomId: atom.id,
    processors: processors,
    type: PROCESSOR_TYPES.DEFAULT
  });
  return defaultProcessor(idx, atom, values);
}

function getValue(idx, atom) {
  var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var val = values.find(function (value) {
    return value.idx === idx;
  }); // if there is no value or if it's a value for a different rule, return the default value

  if (!val || val.id !== atom.id || !isValidValue(atom, val)) {
    return undefined;
  } // otherwise, return the value


  return val;
}

function newRuleValues(_ref5) {
  var _ref5$idx = _ref5.idx,
      idx = _ref5$idx === void 0 ? 0 : _ref5$idx,
      rule = _ref5.rule,
      ruleBook = _ref5.ruleBook,
      processors = _ref5.processors,
      parentValues = _ref5.parentValues;

  if (rule === undefined) {
    rule = ruleBook[ruleBook.entry];
  }

  var _getAtoms = getAtoms({
    idx: idx,
    ruleBook: ruleBook,
    values: [{
      id: rule.id,
      idx: idx,
      value: rule.default
    }],
    processors: processors,
    parentValues: parentValues
  }),
      values = _getAtoms.values;

  return values;
}

function newRule(_ref6) {
  var _ref6$idx = _ref6.idx,
      idx = _ref6$idx === void 0 ? 0 : _ref6$idx,
      rule = _ref6.rule,
      ruleBook = _ref6.ruleBook,
      processors = _ref6.processors,
      parentValues = _ref6.parentValues;

  if (rule === undefined) {
    rule = ruleBook[ruleBook.entry];
  }

  var _getAtoms2 = getAtoms({
    idx: idx,
    ruleBook: ruleBook,
    values: [{
      id: rule.id,
      idx: idx,
      value: rule.default
    }],
    processors: processors,
    parentValues: parentValues
  }),
      values = _getAtoms2.values,
      subRuleId = _getAtoms2.subRuleId,
      requiredSubRule = _getAtoms2.requiredSubRule;

  var subRules = requiredSubRule ? [newRule({
    rule: ruleBook[subRuleId],
    ruleBook: ruleBook,
    processors: processors,
    parentValues: {
      values: values,
      parentValues: parentValues
    }
  })] : [];
  return {
    values: values,
    subRules: subRules
  };
}

function getAtoms(_ref7) {
  var _ref7$idx = _ref7.idx,
      idx = _ref7$idx === void 0 ? 0 : _ref7$idx,
      ruleBook = _ref7.ruleBook,
      _ref7$values = _ref7.values,
      values = _ref7$values === void 0 ? [] : _ref7$values,
      processors = _ref7.processors,
      parentValues = _ref7.parentValues;
  var searching = true;
  var atomId = values.length ? values.find(function (val) {
    return val.idx === idx;
  }).id : ruleBook.entry;
  var atomProcessor = getProcessor({
    atomId: atomId,
    processors: processors,
    type: PROCESSOR_TYPES.ATOM
  });
  var atom = atomProcessor(idx, ruleBook[atomId], values, parentValues);
  /*let atom = values.length
    ? ruleBook[values[idx].id]
    : ruleBook[ruleBook.entry];*/

  var atoms = [atom];
  var updatedValues = [];

  var _getAtomSubRuleId = getAtomSubRuleId({
    idx: idx,
    atom: atom,
    values: values,
    ruleBook: ruleBook
  }),
      subRuleId = _getAtomSubRuleId.subRuleId,
      requiredSubRule = _getAtomSubRuleId.requiredSubRule,
      singleSubRule = _getAtomSubRuleId.singleSubRule,
      subRuleType = _getAtomSubRuleId.subRuleType;

  do {
    var value = getValue(idx, atom, values) || getDefaultValue(idx, atom, updatedValues, processors);

    if (value !== undefined) {
      updatedValues.push(value);
    }

    atom = getNextAtom({
      atom: atom,
      idx: idx,
      values: updatedValues,
      ruleBook: ruleBook,
      processors: processors,
      parentValues: parentValues
    });

    if (atom) {
      atoms.push(atom);
      idx++;

      var _getAtomSubRuleId2 = getAtomSubRuleId({
        idx: idx,
        atom: atom,
        values: values,
        ruleBook: ruleBook
      }),
          atomSubRuleId = _getAtomSubRuleId2.subRuleId,
          atomRequiredSubRule = _getAtomSubRuleId2.requiredSubRule,
          atomSingleSubRule = _getAtomSubRuleId2.singleSubRule,
          atomSubRuleType = _getAtomSubRuleId2.subRuleType;

      if (atomSubRuleId !== undefined) {
        subRuleId = atomSubRuleId;
      }

      if (atomRequiredSubRule !== undefined) {
        requiredSubRule = atomRequiredSubRule;
      }

      if (atomSingleSubRule !== undefined) {
        singleSubRule = atomSingleSubRule;
      }

      if (atomSubRuleType !== undefined) {
        subRuleType = atomSubRuleType;
      }
    } else {
      searching = false;
    }
  } while (searching);

  return {
    atoms: atoms,
    subRuleId: subRuleId,
    subRuleType: subRuleType,
    values: updatedValues,
    requiredSubRule: requiredSubRule,
    singleSubRule: singleSubRule
  };
}

function updateRule(_ref8) {
  var _ref8$idx = _ref8.idx,
      idx = _ref8$idx === void 0 ? 0 : _ref8$idx,
      atom = _ref8.atom,
      rule = _ref8.rule,
      unprocessedValue = _ref8.unprocessedValue,
      ruleBook = _ref8.ruleBook,
      processors = _ref8.processors,
      parentValues = _ref8.parentValues;
  var processor = getProcessor({
    atomId: atom.id,
    processors: processors,
    type: PROCESSOR_TYPES.VALUE
  });
  var value = processor(idx, atom, unprocessedValue, rule.values, parentValues); // (idx, atom, value, values) => value

  var newValues = rule.values.filter(function (val) {
    return val.idx <= idx;
  });
  var remainderValues = rule.values.filter(function (val) {
    return val.idx > idx;
  });
  var valueIdx = newValues.findIndex(function (val) {
    return val.idx === idx;
  }); // this is vestigal, I think. Previously, we could add on values to the end of a rule, but now we
  // can't. So the conditional would always fail. So it's turned off, but commented in case I think of how to
  // do it again.
  //
  // if (valueIdx >= 0) {

  newValues[valueIdx] = {
    id: atom.id,
    idx: idx,
    value: value
  }; // } else {
  //   newValues.push({ id: atom.id, idx, value });
  // }

  if (remainderValues.length) {
    // okay, this gets tricky fast. Start peeling off atoms from the rule.
    // we need to keep track of the last atom value and idx.
    var lastAtom = atom;
    var lastAtomIdx = idx;

    var reindexer = function reindexer(array, newIdx) {
      return array.map(function (val) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, val), {}, {
          // our new index is the lastAtomIdx + 1 (to reach the 0 value idx)
          // + our original idx - the original first value idx. This will offset our value
          // properly.
          idx: lastAtomIdx + 1 + val.idx - remainderValues[0].idx
        });
      });
    };

    do {
      var nextAtom = getNextAtom({
        atom: lastAtom,
        idx: lastAtomIdx,
        values: newValues,
        ruleBook: ruleBook,
        processors: processors,
        parentValues: parentValues
      }); // if our -next- atom is going to match our -first- value, then we can safely
      // assume that the values are still useful to keep. In that case, we store the values
      // and re-index them.

      if (nextAtom !== undefined && nextAtom.id === remainderValues[0].id) {
        var reindexedValues = reindexer(remainderValues, lastAtomIdx + 1);
        newValues.push.apply(newValues, (0, _toConsumableArray2.default)(reindexedValues));
        break;
      } else if (nextAtom !== undefined) {
        // otherwise, we're seeing a new atom that is -not- one of the remainder Values.
        // add on its default.
        var defaultValue = getDefaultValue(lastAtomIdx + 1, nextAtom, newValues, processors);

        if (defaultValue !== undefined) {
          newValues.push(defaultValue);
        }
      }

      lastAtom = nextAtom;
      lastAtomIdx++;
    } while (lastAtom !== undefined);
  } // I'm pretty sure this conditional is vestigal. Leaving it in until I'm positive.
  //if (newValues.length) {
  // now, we may have set a new last atom/value and we need to populate later defaults.


  var _getAtoms3 = getAtoms({
    ruleBook: ruleBook,
    values: newValues,
    processors: processors,
    parentValues: parentValues
  }),
      unfilteredDefaultValues = _getAtoms3.values;

  var moreDefaultValues = unfilteredDefaultValues.filter(function (val) {
    return val.idx > newValues[newValues.length - 1].idx;
  });
  newValues.push.apply(newValues, (0, _toConsumableArray2.default)(moreDefaultValues)); //}

  var res = getAtoms({
    ruleBook: ruleBook,
    values: newValues,
    processors: processors,
    parentValues: parentValues
  });
  var subRuleId = res.subRuleId,
      requiredSubRule = res.requiredSubRule,
      subRuleType = res.subRuleType;
  var filteredSubRules = rule.subRules.filter(function (subRule) {
    return !subRule.values.length || subRule.values[0].id === subRuleId;
  });
  var newSubRules = filteredSubRules.length === rule.subRules.length ? rule.subRules : filteredSubRules;

  if (requiredSubRule && newSubRules.length === 0) {
    newSubRules.push(newRule({
      rule: ruleBook[subRuleId],
      ruleBook: ruleBook,
      processors: processors,
      parentValues: {
        values: newValues,
        parentValues: parentValues
      }
    }));
  }

  return {
    values: newValues,
    subRules: newSubRules,
    subRuleType: subRuleType
  };
}

function isValidValue(atom, val) {
  var validator = dispatch.validator[atom.type];

  if (validator === undefined) {
    throw new Error("Cannot validate values for atom of type ".concat(atom.type));
  }

  return validator(atom, val);
}

function isGenericValidValue(atom) {
  var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref9.value;

  return true;
}

function registerType(_ref10) {
  var type = _ref10.type,
      Component = _ref10.Component,
      _ref10$nextAtom = _ref10.nextAtom,
      nextAtom = _ref10$nextAtom === void 0 ? getNextGenericAtom : _ref10$nextAtom,
      _ref10$subRule = _ref10.subRule,
      subRule = _ref10$subRule === void 0 ? getGenericAtomSubRuleId : _ref10$subRule,
      _ref10$validator = _ref10.validator,
      validator = _ref10$validator === void 0 ? isGenericValidValue : _ref10$validator,
      _ref10$atomProcessor = _ref10.atomProcessor,
      atomProcessor = _ref10$atomProcessor === void 0 ? defaultAtomProcessor : _ref10$atomProcessor;
  dispatch.component[type] = Component;
  dispatch.nextAtom[type] = nextAtom;
  dispatch.subRule[type] = subRule;
  dispatch.validator[type] = validator;
  dispatch.atomProcessor[type] = atomProcessor;
}

function unregisterType(type) {
  delete dispatch.nextAtom[type];
  delete dispatch.subRule[type];
  delete dispatch.component[type];
  delete dispatch.validator[type];
  delete dispatch.atomProcessor[type];
}